import React from 'react';
import { User } from '../context/AuthContext';
import { useLives } from '../context/LivesContext';
import { COLORS } from '../constants';

interface UserHeaderProps {
  user: User | null;
}

const UserHeader: React.FC<UserHeaderProps> = ({ user }) => {
  const { lives } = useLives();
  
  if (!user) return null;

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem', marginTop: '0.5rem' }}>
      <h2 style={{ color: COLORS.GRAY, margin: 0 }}>{user.email}!</h2>
      <div style={{ 
        background: COLORS.LIGHT_BLUE, 
        padding: '0.25rem 0.75rem', 
        borderRadius: '999px', 
        fontSize: '0.875rem', 
        color: COLORS.BLUE, 
        display: 'flex', 
        alignItems: 'center', 
        gap: '0.25rem' 
      }}>
        Lives: {lives} <span style={{ fontSize: '1rem' }}>❤️</span>
      </div>
    </div>
  );
};

export default UserHeader; 